import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Badge } from 'reactstrap';
import { connect } from 'react-redux';
import { getUserReferenceList } from '../../../actions';
import { getDetailedUser } from '../../../actions/users';
import { GET_WORKER_DETAILS_SUCCESS } from '../../../actions/actionTypes';
import { appPath } from '../../../constants';
import BackArrow from '../../common/ui/BackArrow';

class References extends Component {
  constructor (props) {
    super(props);
    this.state = { references: [], user: {} };
  }

  handleChange = event => this.setState({ [event.target.name]: event.target.value });

  componentDidMount () {
    const { getUserReferenceList, getDetailedUser, match: { params: { id } } } = this.props;
    getUserReferenceList(id)
      .then(references => getDetailedUser(id, GET_WORKER_DETAILS_SUCCESS)
        .then(user => this.setState({ references, user })));
  }

  render () {
    const { t, match: { params: { id } } } = this.props;
    const { references, user: { first_name: first, last_name: last } } = this.state;
    const putUser = string => string.replace(/_worker_/img, `${first || ''} ${last || ''}`);
    return (
      <div className='col col-12'>
        <BackArrow
          history={this.props.history}
          location={this.props.location}
          defaultBackPath={`/${appPath}/workers/${id}`}
        />
        {references.length ? (
          references.map(ref => {
            const { is_supervisor, first_name, last_name, email, q1 } = ref;
            const role = is_supervisor ? 'supervisor' : 'coWorker';

            return (
              <div key={ref.id}>
                <div className='mb-3'>
                  <div className='d-flex align-items-center'>
                    <h3 className='mb-0'>Reference
                      from {first_name} {last_name}</h3>
                    <Badge color='success' className='ml-3'>{role}</Badge>
                  </div>
                  <a href={`mailto:${email}`}>
                    <small className='text-muted'>{email}</small>
                  </a>
                </div>
                {!q1 &&
                <h2 className='m-0'><Badge color='info'>Processing</Badge></h2>}
                <ol className='pl-0 ml-3'>
                  {ref.q1 &&
                  <li className='mb-2'>{putUser(t(`ref:${role}.q1`))} <Badge
                    color='info'>{ref.q1}</Badge></li>}
                  {ref.q2 &&
                  <li className='mb-2'>{putUser(t(`ref:${role}.q2`))} <Badge
                    color='info'>{ref.q2}</Badge></li>}
                  {ref.q3 &&
                  <li className='mb-2'>{putUser(t(`ref:${role}.q3`))} <Badge
                    color='info'>{ref.q3}</Badge></li>}
                  {ref.q4 &&
                  <li className='mb-2'>{putUser(t(`ref:${role}.q4`))} <Badge
                    color='info'>{ref.q4}</Badge></li>}
                  {ref.q5 &&
                  <li className='mb-2'>{putUser(t(`ref:${role}.q5`))} <Badge
                    color='info'>{ref.q5}</Badge></li>}
                  {ref.q6 &&
                  <li className='mb-2'>{putUser(t(`ref:${role}.q6`))} <Badge
                    color='info'>{ref.q6}</Badge></li>}
                  {ref.q7 &&
                  <li className='mb-2'>{putUser(t(`ref:${role}.q7`))} <Badge
                    color='info'>{ref.q7}</Badge></li>}
                  {ref.q8 &&
                  <li className='mb-2'>{putUser(t(`ref:${role}.q8`))} <Badge
                    color='info'>{ref.q8}</Badge></li>}
                  {ref.q9 &&
                  <li className='mb-2'>{putUser(t(`ref:${role}.q9`))} <Badge
                    color='info'>{ref.q9}</Badge></li>}
                </ol>
                <hr />
              </div>
            );
          })
        ) : `No references yet`}
      </div>
    );
  }
}

export default translate()(connect(null, { getUserReferenceList, getDetailedUser })(References));



// WEBPACK FOOTER //
// ./src/components/app/workerDetails/References.js